import type { ReactNode } from "react";
import { Link } from "react-router-dom";

/** A panel heading's way out to the full page the panel summarises. */
export function PanelLink({ to, children }: { readonly to: string; readonly children: ReactNode }) {
  return (
    <Link
      to={to}
      className="text-micro font-semibold uppercase text-ink-faint no-underline transition-colors duration-fast ease-swiss hover:text-ink"
    >
      {children} →
    </Link>
  );
}
